module.exports = __webpack_public_path__ + "static/media/logo.599c50a9.jpg";